import { useEffect } from 'react';
import { goodThingsService } from '../services/goodThings';

export const useDropdownData = () => {
  useEffect(() => {
    // Load dropdown data when the app initializes
    const loadDropdownData = async () => {
      try {
        await goodThingsService.getDropdownData();
      } catch (error) {
        console.error('Error preloading dropdown data:', error);
      }
    };

    loadDropdownData();
  }, []); // Empty dependency array means this runs once on mount
};
